import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Layout = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  display: none;

  ${mediaQueries.laptop} {
    display: block;
  }
`

export const Frame = styled.div`
  position: absolute;
  border-radius: var(--radius-brand);
  border: 2px solid var(--border-brand);
  transition:
    opacity 0.2s ease-in-out,
    visibility 0.2s ease-in-out;
`
